<button type="button" class="navbar-toggler" (click)="sideNavService.toggleSideNav()">
	<i class="fa fa-bars toggle-arrow" [ngClass]="{ rotateArrow: sideNavService.hideSideNav }"></i>
</button>
